<template>
  <div>
    <wc-page-title title='My Tasks' :loading='isLoading'></wc-page-title>
    <v-container>
      <tasks-table
        :managedTasks='managedTasks'
        :assignedTasks='assignedTasks'
        :profiles='profiles'
        @update='update'
        @create='create'
        @deleteTask='deleteTask'
      ></tasks-table>
    </v-container>
  </div>
</template>

<script>
import TasksTable from '@/modules/tasks/components/TasksTable'
import staffingAPI from '@/modules/staffing/api/staffing'
import tasksAPI from '@/modules/tasks/api/tasks'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'my-tasks',
  data: () => ({
    isLoading: true,
    tasks: [],
    profiles: []
  }),
  components: {
    'tasks-table': TasksTable
  },
  mounted () {
    this.getData()
  },
  computed: {
    // tasks are split up here to avoid duplication in assiged / managed tables
    assignedTasks () { 
      return _.sortBy(_.filter(this.tasks, t => t.assigned_to == this.$store.state.auth.profile.id), 'date_due')
    },
    managedTasks () {
      return _.sortBy(_.filter(this.tasks, t => t.assigned_to != this.$store.state.auth.profile.id && t.task_manager == this.$store.state.auth.profile.id), 'date_due')
    }
  },
  methods: {
    async getData () {
      this.isLoading = true
      let assigned = await tasksAPI.getAssignedTasks(this.$store.state.auth.profile.id)
      let managed = await tasksAPI.getManagedTasks(this.$store.state.auth.profile.id)
      this.tasks = _.unionBy(assigned, managed, 'id')
      let staff = await staffingAPI.getProfiles()
      this.profiles = _.orderBy(staff.filter(s => s.is_active === true), 'name_display')
      this.isLoading = false
    },
    async update (task) {
      this.isLoading = true
      let tmp = await tasksAPI.updateTask(task)
      miscServices.replaceObject(this.tasks, tmp)
      this.isLoading = false
    },
    async create (task) {
      this.isLoading = true
      let tmp = await tasksAPI.createTask(task)
      this.tasks.push(tmp)
      this.isLoading = false
    },
    async deleteTask (task) {
      this.isLoading = true
      await tasksAPI.deleteTask(task.id)
      miscServices.removeObject(this.tasks, task)
      this.isLoading = false
    }
  }
}
</script>
